import { useAllTransactions } from 'lib/hooks/queries/admin/useAllTransactions';

import AgTablePage from 'components/shared/AgTablePage/AgTablePage';
import { withErrorBoundary } from 'components/shared/Error/Boundary';
import TransactionResponseModal from 'components/practice/charts/billing/transactions/TransactionResponseModal';

import { COLUMNS } from './lib/columns';
import { DEFAULT_FILTERS } from './lib/filters';

const AllTransactionsTable = () => {
  return (
    <AgTablePage
      ModalComponent={TransactionResponseModal}
      useData={useAllTransactions}
      defaultColumns={COLUMNS}
      defaultFilters={DEFAULT_FILTERS}
      disabledCells={['tagLinks']}
      name="transactions"
      title="All transactions"
      queryParams={{ withCount: true }}
      noNewButton
    />
  );
};

export default withErrorBoundary(AllTransactionsTable);
